import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { formatApiErrorDetail } from "../auth/AuthContext";
import { AuthAside, AuthLegal } from "../components/AuthAside";
import "./Auth.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate("/login", { replace: true }), 2200);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <AuthAside />
      <main className="auth-main">
        <div className="auth-card" data-testid="reset-card">
          <h1 className="auth-title">New password</h1>
          <p className="auth-lede">Choose a new password for your account.</p>

          {!token && <div className="auth-error">This reset link is missing its token. Please request a new one.</div>}
          {error && <div className="auth-error" data-testid="reset-error">{error}</div>}

          {done ? (
            <div className="auth-success" data-testid="reset-success">
              Your password has been reset. Redirecting you to sign in…
            </div>
          ) : (
            <form onSubmit={submit} className="auth-form">
              <div className="auth-field">
                <label htmlFor="reset-pw-input">New password</label>
                <input id="reset-pw-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  required autoComplete="new-password" placeholder="At least 8 characters" data-testid="reset-password" />
              </div>
              <div className="auth-field">
                <label htmlFor="reset-confirm-input">Confirm password</label>
                <input id="reset-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  required autoComplete="new-password" data-testid="reset-confirm" />
              </div>
              <button className="auth-btn" type="submit" disabled={loading || !token} data-testid="reset-submit">
                {loading ? "Resetting…" : "Reset password"}
              </button>
            </form>
          )}

          <p className="auth-foot">
            <Link to="/login" data-testid="reset-back-login">Back to sign in</Link>
          </p>
        </div>

        <AuthLegal />
      </main>
    </div>
  );
}
